"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const radioStyled_1 = __importDefault(require("../../../../../../../shared/components/radio/radioStyled"));
require("./locationOpt.scss");
const editProps = [
    {
        name: "Single State",
        key: "single_state",
        multiline: false,
        checkedStatus: true,
    },
    {
        name: "Multiple Locations",
        key: "multiple_location",
        multiline: false,
        checkedStatus: false,
    },
    {
        name: "Nationwide",
        key: "nationwide",
        multiline: false,
        checkedStatus: false,
    }
];
const EditExpert = (props) => {
    const { expert } = props;
    const [value, setValue] = react_1.default.useState(editProps);
    const [location, setLocation] = react_1.default.useState(true);
    const [state, setState] = react_1.default.useState('State');
    const onEdit = (e, key) => {
        const val = e.target.value;
        props.editExpert({ key, val });
    };
    // choose  location option
    const locationChange = (key) => {
        const arr = [...value].map((item, index) => {
            item.checkedStatus = (index == key) ? true : false;
            return item;
        });
        setValue(arr);
        if (editProps[key].checkedStatus === true && editProps[key].key === 'single_state') {
            setLocation(true);
        }
        else {
            setLocation(false);
        }
    };
    // change states
    const handleChange = (event) => {
        setState(event.target.value);
    };
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks location-option' },
        react_1.default.createElement("h5", null, "Location Options"),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(core_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(core_1.RadioGroup, { value: true, row: true, "aria-label": "Location Option", className: 'location-list', name: "pro-bono-radios" }, editProps.map((val, key) => {
                        return (react_1.default.createElement(core_1.FormControlLabel, { value: val.checkedStatus, onClick: () => locationChange(key), control: react_1.default.createElement(radioStyled_1.default, null), labelPlacement: "end", label: val.name, key: key }));
                    })))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 }, location ? (react_1.default.createElement(core_1.FormControl, { variant: "outlined", className: "state" },
                react_1.default.createElement(core_1.InputLabel, { id: "demo-simple-select-outlined-label" }, "State"),
                react_1.default.createElement(core_1.Select, { labelId: "demo-simple-select-outlined-label", id: "demo-simple-select-outlined", value: state, defaultValue: 10, onChange: handleChange, label: "State" },
                    react_1.default.createElement(core_1.MenuItem, { value: "" },
                        react_1.default.createElement("em", null, "None")),
                    react_1.default.createElement(core_1.MenuItem, { value: 10 }, "Ten"),
                    react_1.default.createElement(core_1.MenuItem, { value: 20 }, "Twenty"),
                    react_1.default.createElement(core_1.MenuItem, { value: 30 }, "Thirty")))) : (react_1.default.createElement(react_1.Fragment, null)))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        EditExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EditExpert);
